$(function() {
   const swiperHeroThumbs = new Swiper('.swiper-hero-thumbs', {
        effect: 'fade',
        slidesPerView: 1,
        allowTouchMove: false,
        fadeEffect: {
            crossFade: true
        },
   });
    const swiperHero = new Swiper('.swiper-hero', {
        slidesPerView: 1,
        effect: 'fade',
        allowTouchMove: false,
        navigation: {
            nextEl: '.hero .swiper-button-next',
            prevEl: '.hero .swiper-button-prev',
        },
        fadeEffect: {
            crossFade: true
        },
         thumbs: {
            swiper: swiperHeroThumbs,
        },
    });

    $('.swiper-container').each(function (index, element) {
        const $element = $(element); 

        const next = $element.find('.swiper-button-next').get(0); 
        const prev = $element.find('.swiper-button-prev').get(0); 


        new Swiper($element.find('.swiper').get(0), { 
            loop: false,
            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
                993: {
                    slidesPerView: 4,
                    spaceBetween: 15,
                }
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
        });
        
    });

        let timeoutShowId;
        let timeoutPauseId;
        let cycleRunning = false;
        const onDuration = 4000;   
        const pauseDuration = 1000; 

        function startInspireCycle() {
            if (cycleRunning) return;
            cycleRunning = true;
            const $el = $('#be-inspired-section');

            const runOnce = () => {
                if (!cycleRunning) return;
                $el.addClass('in-view');
                timeoutShowId = setTimeout(() => {
                    $el.removeClass('in-view');
                    if (cycleRunning) {
                        timeoutPauseId = setTimeout(runOnce, pauseDuration);
                    }
                }, onDuration);
            };

            runOnce();
        }

        function stopInspireCycle() {
            cycleRunning = false;
            clearTimeout(timeoutShowId);
            clearTimeout(timeoutPauseId);
            $('#be-inspired-section').removeClass('in-view');
        }
    
    let setTimeID;

    $(document).on("mouseenter", ".spot", function() {
        if (window.innerWidth < 992) return;
        const $this = $(this);
        const hoverSpot = $this.data("hover-spot");
        $('.horizontal-thumb[data-product="' + hoverSpot + '"]').addClass("active");
        stopInspireCycle()
        clearTimeout(setTimeID);
    }).on("mouseleave", ".spot", function() {
        if (window.innerWidth < 992) return;

        const $this = $(this);
        const hoverSpot = $this.data("hover-spot");
        $('.horizontal-thumb[data-product="' + hoverSpot + '"]').removeClass("active");
        setTimeID = setTimeout(() => {
            startInspireCycle();
        }, 500);
    });

    $(document).on("click", ".spot", function(e) {
        if (window.innerWidth >= 993) return;
        e.preventDefault();
        stopInspireCycle();
        const handle = $(this).data("handle");
        const $targetContainer = $('.other-container');

        $.get(`/products/${handle}?view=horizontal-thumb`, function(snippetHtml) {
            $targetContainer.empty().append(snippetHtml);
            $targetContainer.find('.horizontal-thumb').each(function() {
            const $thumb = $(this);
            const $activeSizes = $thumb.find('.sizes-container.active');
            const $activeColor = $thumb.find('.swatches .color.active');

            $activeSizes.each(function() {
            $(this).find('.btn-rose').removeClass('active');
            $(this).find('.btn-rose:not(.disabled)').first().addClass('active');
            });

            if ($activeColor.hasClass('disabled')) {
                $thumb.find('.add-to-cart').each(function() {
                    $(this).addClass('disabled');
                });
            } 
        });
        });

        e.preventDefault();
        
        $('body').addClass('overflow-hidden');
        const $sheet = $('#container-inspired-sheet');
        const $overlay = $("#overlay-here");

        $overlay.addClass("show");
        $sheet.addClass("show");

        gsap.to($sheet, {
            y: 0, 
            duration: 0.6,
            ease: "customEase",
        });

        Draggable.create($sheet.get(0), {
            trigger: $sheet.find(".drag-area").get(0),
            type: "y",
            bounds: {
                minY: ($sheet.height() * 1) + 50,
                maxY: -10
            },
            onDragEnd: function() {
                if (this.y > $sheet.height() * 0.1) {
                    gsap.to($sheet, {
                        y: ($sheet.height() * 1) + 50,
                        duration: 0.6,
                        ease: "customEase",
                    });

                    $overlay.removeClass("show");
                    $sheet.removeClass("show");
                    $('body').removeClass('overflow-hidden');
                } else {
                    gsap.to($sheet, {
                        y: 0,
                        duration: 0.6,
                        ease: "customEase" 
                    });
                }
            }
        });

       

        
    });
    
    $(document).on("click", "#overlay-here", function() {
        startInspireCycle();
        const $overlay = $('#overlay-here');
        const $sheet = $("#container-inspired-sheet");

        gsap.to($sheet, {
            y: ($sheet.height() * 1) + 50,
            duration: 0.6,
            ease: "customEase",
        });

        $overlay.removeClass("show");
        $sheet.removeClass("show");
        $('body').removeClass('overflow-hidden');
    });


    const options = {
      root: null, 
      rootMargin: '0px 0px 0px 0px', 
      threshold: 0.5 
    };
    
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
            startInspireCycle();
        } else {
            stopInspireCycle();
        }
      });
    }, options);
    
    const target = document.querySelector('#be-inspired-section');
    if (target) observer.observe(target);




});


